import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const login1 = r => require.ensure([], () => r(require('@/page/login1')), 'login1');
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');
const articalList = r => require.ensure([], () => r(require('@/page/articalList')), 'articalList');
// const activity = r => require.ensure([], () => r(require('@/page/activity')), 'activity');
const createArtical = r => require.ensure([], () => r(require('@/page/createArtical')), 'createArtical');
const mainMenueList = r => require.ensure([], () => r(require('@/page/mainMenueList')), 'mainMenueList');
const projectList = r => require.ensure([], () => r(require('@/page/projectList')), 'projectList');
const secondMenueList = r => require.ensure([], () => r(require('@/page/secondMenueList')), 'secondMenueList');
const editArtical = r => require.ensure([], () => r(require('@/page/editArtical')), 'editArtical');
const friendLink = r => require.ensure([], () => r(require('@/page/friendLink')), 'friendLink');
const creatgroup = r => require.ensure([], () => r(require('@/page/creatgroup')), 'creatgroup');
const searchgroup = r => require.ensure([], () => r(require('@/page/searchgroup')), 'searchgroup');
const routes = [{
        path: '/',
        component: login
    },
    {
        path: '/login',
        component: login
    },
    {
        path: '/login1',
        component: login1
    },
    {
        path: '/manage',
        component: manage,
        name: '',
        children: [{
                path: '/projectList',
                component: projectList,
                meta: ['分类管理'],
            },
            {
                path: '/createArtical',
                component: createArtical,
                meta: ['发布资讯'],
            },
            {
                path: '/articalList',
                component: articalList,
                meta: ['咨询列表'],
            },
            {
                path: '/friendLink',
                component: friendLink,
                meta: ['友情链接'],
            },
            {
                path: '/editArtical',
                component: editArtical,
                meta: ['编辑文章'],
            },
            {
                path: '/creatgroup',
                component: creatgroup,
                meta: ['分组管理'],
            },
            {
                path: '/searchgroup',
                component: searchgroup,
                meta: ['推荐文章'],
            },

        ]
    }

]

export default new Router({
    routes,
    // strict: process.env.NODE_ENV !== 'production',
})


// WEBPACK FOOTER //
// ./src/router/index.js